<template>
  <div>
  <Breadcrumbs main="Requests" title="Form A" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-3 pr-sm-0 box-col-12">
          <div class="file-sidebar">
            <div class="card">
              <div class="card-body">
                <ul>
                <li>
                <router-link to="/requestManagement/form-A">
                    <div class="btn btn-primary">
                      <feather type="pocket"></feather>
                      Form A
                    </div>
                    </router-link>
                  </li>
                  <li>
                  <router-link to="/requestManagement/token">
                    <div class="btn btn-light">
                      <feather type="toggle-right"></feather>
                      Hard Token Request
                    </div>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/requestManagement/card">
                    <div class="btn btn-light">
                      <feather type="folder"></feather>
                      Card Management
                    </div>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/requestManagement/cheque">
                    <div class="btn btn-light">
                      <feather type="book"></feather>
                      Cheque Request
                    </div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-md-12 box-col-12">
          <div class="file-content">
            <div class="card">
              <div class="card-header">
                <h5>Form A</h5>
                <span>(PTA, School Fees, Medical Bills and others)</span>
              </div>
              <section class="card-body">
                <h6>Dear {{userName ? userName : 'User'}},</h6>
                <p class="mt-2">Thank you for choosing TAJBank for your Form A request. Please note that CBN has built a robust solution to take care of your Form A needs such as PTA, School Fees, Medical Bills etc. 
                <span class="font-weight-bold font-italic">Please click the link below to access the portal.</span></p>
                <p><span class="font-italic font-weight-bold">Trade Monitoring System </span> <a href="https://www.tradesystem.gov.ng/landing/index.html" target="blank">Tradesystem.gov.ng</a></p>
              </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    data:() => ({
     
    }),
    computed: {
      ...mapState({
        accounts: (state) => state.dashboard.dashboardData,
      }),
      userName() {
        return this.accounts ? this.accounts.customerDetails.firstName : null;
      },
    },
    async mounted() {
    },
    methods : {
    },
  };
</script>
<style scoped>
.file-content .card .card-header,
.file-content .card .card-body {
  padding: 40px !important;
}
.card .card-header h5 {
    font-size: 23px;
    font-weight: 300;
}
.btn-light {
    background-color: #e6e6e6 !important;
    color: #000000!important;
    /* border-color: rgba(228, 31, 19, 0.06) !important; */
}
.theme-form select.acct-num {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-control {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-select {
  width: 100%;
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  color: #898989;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem
}
.form-control::placeholder {
  color: #898989;
}
.pull-right {
  color:#E41613;
}
.btn-outline-danger {
  border-color: #e6e6e6;
  color: #000;
  margin-left: 5px;
}
.swal2-actions >>> .swal2-confirm {
  background-color: #1a803f !important;
}
.loader-12 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5) url("../../assets/TAJimages/backgrounds/taj_loader_sm.gif") center center no-repeat;
  z-index: 1000;
  border-radius: 10px;
}
</style>